import {
	IdentityTypeDecorator, ModelTypeNameDecorator, Expose, Type, OCCAuditDeactivableModel, Transform, DateTimeOffset, TimeSpan, BaseRowNumberModel
} from '@nts/std';
import { SignerLayoutIdentity } from '../../domain-models/signer-layout.identity';
import { NumberDecorator } from '@nts/std';

@IdentityTypeDecorator(SignerLayoutIdentity)
@ModelTypeNameDecorator('SignerLayout')
export class GeneratedSignerLayout extends BaseRowNumberModel<SignerLayoutIdentity> {

	private _signerSerial: number = 0;

	/**
	 Serial
	 */
	@Expose()
	public get signerSerial(): number {
		return this.getValueForIdentityValue<number>(() => this._signerSerial, 'signerSerial');
	}
	public set signerSerial(value: number) {
		this.setValueForIdentityValue<number>(() => { this._signerSerial = value; }, value, 'signerSerial');
	}

	private _templateId: number = 0;

	/**
	 Id Modello
	 */
	@Expose()
	public get templateId(): number {
		return this.getValueForIdentityValue<number>(() => this._templateId, 'templateId');
	}
	public set templateId(value: number) {
		this.setValueForIdentityValue<number>(() => { this._templateId = value; }, value, 'templateId');
	}

	private _signerLayoutSerial: number = 0;

	/**
	 Serial
	 */
	@Expose()
	public get signerLayoutSerial(): number {
		return this.getValueForIdentityValue<number>(() => this._signerLayoutSerial, 'signerLayoutSerial');
	}
	public set signerLayoutSerial(value: number) {
		this.setValueForIdentityValue<number>(() => { this._signerLayoutSerial = value; }, value, 'signerLayoutSerial');
	}

	private _specificPage: number;

	/**
	 Pagina Specifica
	 */
	// @NumberDecorator({ minValue: 5 })
	@Expose()
	public get specificPage(): number {
		return this.getValue<number>(() => this._specificPage, 'specificPage');
	}
	public set specificPage(value: number) {
		this.setValue<number>(() => { this._specificPage = value; }, value, 'specificPage');
	}

	private _lastPage: boolean;

	/**
	 Ultima Pagina
	 */
	@Expose()
	public get lastPage(): boolean {
		return this.getValue<boolean>(() => this._lastPage, 'lastPage');
	}
	public set lastPage(value: boolean) {
		this.setValue<boolean>(() => { this._lastPage = value; }, value, 'lastPage');
	}

	private _leftCoordinate: number;

	/**
	 Coordinata Sinistra
	 */
	@Expose()
	public get leftCoordinate(): number {
		return this.getValue<number>(() => this._leftCoordinate, 'leftCoordinate');
	}
	public set leftCoordinate(value: number) {
		this.setValue<number>(() => { this._leftCoordinate = value; }, value, 'leftCoordinate');
	}

	private _topCoordinate: number;

	/**
	 Coordinata Alto
	 */
	@Expose()
	public get topCoordinate(): number {
		return this.getValue<number>(() => this._topCoordinate, 'topCoordinate');
	}
	public set topCoordinate(value: number) {
		this.setValue<number>(() => { this._topCoordinate = value; }, value, 'topCoordinate');
	}
}
